if (!customElements.get("variant-picker")) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
    }

    get selectedOptionValues() {
      const options = this.querySelectorAll(
        "select, .variant-picker__field input[type='radio']"
      );
      const selectedValues = new Map();

      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;

        if (field.tagName.toLowerCase() === "select") {
          const selectedOption = Array.from(field.options).find(
            (opt) => opt.selected && !opt.disabled
          );
          if (selectedOption) {
            selectedValues.set(fieldName, selectedOption.dataset.optionValueId);
          }
        } else if (
          field.tagName.toLowerCase() === "input" &&
          field.type === "radio"
        ) {
          if (field.checked) {
            selectedValues.set(fieldName, field.dataset.optionValueId);
          }
        }
      });

      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;

        if (!selectedValues.has(fieldName)) {
          if (field.tagName.toLowerCase() === "select") {
            const firstValidOption = Array.from(field.options).find(
              (opt) => !opt.disabled
            );
            if (firstValidOption) {
              selectedValues.set(
                fieldName,
                firstValidOption.dataset.optionValueId
              );
            }
          } else if (
            field.tagName.toLowerCase() === "input" &&
            field.type === "radio"
          ) {
            selectedValues.set(fieldName, field.dataset.optionValueId);
          }
        }
      });

      const result = [];
      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;
        if (selectedValues.has(fieldName)) {
          const optionValueId = selectedValues.get(fieldName);
          if (optionValueId && !result.includes(optionValueId)) {
            result.push(optionValueId);
          }
        }
      });

      return result;
    }

    getInputForEventTarget(target) {
      return target.tagName === "SELECT"
        ? target.selectedOptions[0]
        : target;
    }

    connectedCallback() {
      this.addEventListener("change", (event) => {
        const target = this.getInputForEventTarget(event.target);

        const selectedOptionValues = this.selectedOptionValues;

        window.FoxThemeEvents.emit(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          {
            data: {
              event,
              target,
              selectedOptionValues,
            },
          }
        );

        document.dispatchEvent(
          new CustomEvent("variant:changed", {
            detail: {
              event,
              selectedOptionValues,
            },
          })
        );

        // ✅ FIX: only visual sync (does NOT touch variant logic)
        requestAnimationFrame(() => {
          this.querySelectorAll(".variant-picker__option").forEach(
            (wrapper) => {
              const input = wrapper.querySelector("input[type='radio']");
              const label = wrapper.querySelector("label");

              if (!input || !label) return;

              if (input.checked) {
                label.classList.add("is-active");
              } else {
                label.classList.remove("is-active");
              }
            }
          );
        });
      });
    }
  }

  customElements.define("variant-picker", VariantPicker);
}